import { render, staticRenderFns } from "./applicant-form.vue?vue&type=template&id=5d306ac8&scoped=true"
import script from "./applicant-form.vue?vue&type=script&lang=js"
export * from "./applicant-form.vue?vue&type=script&lang=js"
import style0 from "./applicant-form.vue?vue&type=style&index=0&id=5d306ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d306ac8",
  null
  
)

export default component.exports